import React from 'react';

/** Epic Games — stylised "E" chevron */
export function EpicIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M4 3h16v3.5H8.5v3H18v3H8.5v3.5H20V21H4V3z" />
    </svg>
  );
}

/** Steam — circular wave logo */
export function SteamIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M11.979 0C5.363 0 0 5.374 0 12.011c0 5.214 3.31 9.65 7.964 11.297L6.845 19.35c-.433-1.648.327-3.374 1.857-4.118 1.493-.73 3.291-.311 4.317 1.015l.083.112a2.688 2.688 0 00.432.446 2.7 2.7 0 003.8-.32l.022-.03c.722-.866.884-2.068.388-3.097l-.036-.087a2.682 2.682 0 00-.404-.635l-.124-.14c-.994-1.347-.829-3.259.378-4.414 1.182-1.141 3.019-1.245 4.328-.259l.134.107A11.95 11.95 0 0011.98 0z" />
    </svg>
  );
}

/** GOG — stylised "G" mark */
export function GOGIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 3a7 7 0 110 14A7 7 0 0112 5zm0 2a5 5 0 100 10A5 5 0 0012 7zm2 2.5v1.75h-1V9.5H12v5h1v-1.75h1V14.5a3 3 0 11-3.5-2.958V9.5H14z" />
    </svg>
  );
}

/** Itch.io — window/game controller shape */
export function ItchioIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M3.13 1.338C2.08 1.96.02 4.328 0 4.95v1.03c0 1.303 1.22 2.45 2.325 2.45 1.33 0 2.436-1.102 2.436-2.41 0 1.308 1.07 2.41 2.4 2.41 1.33 0 2.365-1.102 2.365-2.41 0 1.308 1.106 2.41 2.436 2.41h.077c1.33 0 2.436-1.102 2.436-2.41 0 1.308 1.035 2.41 2.365 2.41 1.33 0 2.4-1.102 2.4-2.41 0 1.308 1.106 2.41 2.436 2.41C22.78 8.43 24 7.283 24 5.98V4.95c-.02-.622-2.08-2.99-3.13-3.612C18.942.696 14.5.5 12 .5S5.058.696 3.13 1.338zM8 10.5v11h2v-4h4v4h2v-11H8zm2 2h4v3h-4v-3z" />
    </svg>
  );
}

/** GameDroplogo mark — bold "GD" monogram in a shield/drop shape */
export function GameDropIcon({ size = 28, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      {/* Shield / drop shape background */}
      <path
        d="M16 2L4 7v9c0 6.075 5.25 11.5 12 14 6.75-2.5 12-7.925 12-14V7L16 2z"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <path
        d="M16 2L4 7v9c0 6.075 5.25 11.5 12 14 6.75-2.5 12-7.925 12-14V7L16 2z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeOpacity="0.6"
      />
      {/* Bold "G" */}
      <text
        x="7"
        y="20"
        fontFamily="'Arial Black', Arial, sans-serif"
        fontWeight="900"
        fontSize="11"
        fill="currentColor"
      >G</text>
      {/* Bold "D" */}
      <text
        x="16"
        y="20"
        fontFamily="'Arial Black', Arial, sans-serif"
        fontWeight="900"
        fontSize="11"
        fill="currentColor"
        fillOpacity="0.75"
      >D</text>
    </svg>
  );
}

/** Generic fallback icon */
export function DefaultPlatformIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M21 6H3a1 1 0 00-1 1v10a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1zM7 14H5v-2H3v-2h2V8h2v2h2v2H9v2H7v-2zm7.5 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-3a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
    </svg>
  );
}

/** Map platform ID → icon component */
export const PLATFORM_ICON_MAP = {
  epic:         EpicIcon,
  steam:        SteamIcon,
  gog:          GOGIcon,
  itchio:       ItchioIcon,
};

export function PlatformIconComponent({ platform, size = 16, className }) {
  const Icon = PLATFORM_ICON_MAP[platform] || DefaultPlatformIcon;
  return <Icon size={size} className={className} />;
}
